import '../../../styles/src/05-components/faq/style.scss';

document.addEventListener(
    "DOMContentLoaded", () => {

        // Expand/Collapse body content on click
        let faqQuestion = document.querySelectorAll('.faq__question');
        faqQuestion.forEach(function(element) {
            const faqAnswer = element.nextElementSibling;
            element.addEventListener("click", function() {
                const faqToggle = element.children[0];
                if (faqToggle.classList.contains('faq__toggle--up')) {
                    faqToggle.classList.remove('faq__toggle--up');
                } else {
                    faqToggle.classList.add('faq__toggle--up');
                }

                if (faqAnswer.clientHeight === 0) {
                    faqAnswer.style.height = faqAnswer.scrollHeight + 'px';
                } else {
                    faqAnswer.style.height = 0;
                }
            });
        });
    }
);